// autogenerated by channel_search/generate.py -- do not edit
import { ReturnToDockInfo } from "@skydio/pbtypes/pbtypes/vehicle/dock_client/return_to_dock_info_pb";
export { ReturnToDockInfo };

export const RETURN_TO_DOCK_INFO_PB = {
  channel: "RETURN_TO_DOCK_INFO_PB",
  type: ReturnToDockInfo.deserializeBinary
};
